import { useState } from "react";
import { Menu, X, Phone, Facebook, Instagram } from "lucide-react";
import { SITE } from "@/lib/site";

const NAV = [
  { id: "tjanster", label: "Tjänster" },
  { id: "projekt", label: "Projekt" },
  { id: "kontakt", label: "Kontakt" },
  { id: "omdomen", label: "Omdömen" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0B132B] border-b-2 border-[#D92525]"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-5 md:px-10 py-3 md:py-5 flex items-center justify-between gap-3 md:gap-4">
        <a
          href="#top"
          data-testid="logo-link"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("top");
          }}
          className="flex items-center"
        >
          <span className="inline-flex flex-col items-center leading-none">
            <span className="font-display font-black tracking-tight text-white text-[2rem] sm:text-4xl md:text-5xl xl:text-7xl">
              SWED<span className="text-[#D92525]">CRO</span>
            </span>
            <span
              data-testid="logo-tagline"
              className="block w-full text-center whitespace-nowrap font-body text-[13px] sm:text-[14px] md:text-[16px] xl:text-[24px] tracking-[0.2em] sm:tracking-[0.28em] uppercase text-white/75 mt-1.5 md:mt-2"
            >
              Måleri &amp; Fasad
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="font-display text-lg xl:text-xl font-semibold tracking-wide text-white hover:text-[#D92525] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-4">
          <a
            href={SITE.phoneHref}
            data-testid="header-phone"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap font-display font-bold text-base xl:text-lg text-white hover:text-[#D92525] transition-colors"
          >
            <Phone size={22} strokeWidth={2.5} />
            {SITE.phone}
          </a>
          <div className="hidden md:flex items-center gap-3 border-l border-white/25 pl-4">
            <a
              href={SITE.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="header-facebook"
              className="text-white hover:text-[#D92525] transition-colors"
            >
              <Facebook size={26} strokeWidth={2} />
            </a>
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="header-instagram"
              className="text-white hover:text-[#D92525] transition-colors"
            >
              <Instagram size={26} strokeWidth={2} />
            </a>
          </div>
          <button
            data-testid="header-cta"
            onClick={() => scrollTo("kontakt")}
            className="inline-flex whitespace-nowrap btn-primary !py-3 !px-3 !text-[11px] sm:!px-5 sm:!text-sm md:!py-4 md:!px-7 md:!text-base"
          >
            Få offert
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden shrink-0 p-2 border-2 border-white text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Meny"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#0B132B] border-t-2 border-[#D92525]">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-left py-3 px-2 font-display font-semibold text-white border-b border-white/15 hover:text-[#D92525]"
              >
                {n.label}
              </button>
            ))}
            <a
              href={SITE.phoneHref}
              data-testid="mobile-phone"
              className="mt-2 inline-flex items-center gap-2 py-3 px-2 font-display font-bold text-white"
            >
              <Phone size={16} /> {SITE.phone}
            </a>
            <div className="flex items-center gap-4 px-2 pt-1">
              <a
                href={SITE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="mobile-facebook"
                className="text-white hover:text-[#D92525]"
              >
                <Facebook size={20} />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="mobile-instagram"
                className="text-white hover:text-[#D92525]"
              >
                <Instagram size={20} />
              </a>
            </div>
            <button
              data-testid="mobile-cta"
              onClick={() => scrollTo("kontakt")}
              className="btn-primary mt-2"
            >
              Få en fri offert
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
